import React from 'react'

import SurveyCreateEventSetting from './SurveyCreateEventSetting'
import ActivateIntegrationButtonSection from 'components/ActivateIntegrationButtonSection'

/**
 * @typedef {object} IntegrationSetting
 * @property {number} id
 * @property {string} name
 * @property {string} integration_type
 * @property {boolean} is_active
 *
 * @param {object} props
 * @param {boolean} props.isAuthenticated
 * @param {IntegrationSetting} props.integrationSetting
 * @param {function} props.activateIntegration
 * @param {function} props.deactivateIntegration
 * @param {boolean} props.updateCompanyIntegrationSettingAPILoading
 * @param {array} props.surveyIntegrationSettings
 */
export default function IntercomCreateEventIntegration({
  isAuthenticated,
  integrationSetting,
  activateIntegration,
  deactivateIntegration,
  surveyIntegrationSettings,
  updateCompanyIntegrationSettingAPILoading,
}) {
  const isIntegrationActive = integrationSetting.is_active

  return (
    <React.Fragment>
      <div className="grid grid-cols-2 mb3">
        <div>
          <p>Contact events can be created each time a customer responds to a survey.</p>
          <p>
            This enables you to to use Intercom’s event-based rules for automated posts and
            messages.
          </p>
          <p>
            <a
              href="https://help.simplesat.io/en/articles/5230032-intercom-integration#h_9c46f5414a"
              target="_blank"
              rel="noreferrer"
            >
              <i className="icon far fa-book" />
              Learn more about creating contact events from feedback
            </a>
          </p>

          <ActivateIntegrationButtonSection
            activateIntegration={activateIntegration}
            deactivateIntegration={deactivateIntegration}
            loading={updateCompanyIntegrationSettingAPILoading}
            isAuthenticated={isAuthenticated}
            isIntegrationActive={isIntegrationActive}
            integrationType="Intercom"
          />
        </div>
        <div>
          <img
            src="https://cdn.simplesat.io/intercom/create-contact-events-from-feedback.png"
            alt="Create contact events from feedback"
            className="ui bordered image float-right"
          />
        </div>
      </div>

      <div>
        <h4>Surveys</h4>
        {surveyIntegrationSettings.map((surveyIntegrationSetting, index) => (
          <SurveyCreateEventSetting
            key={index}
            surveyIntegrationSetting={surveyIntegrationSetting}
            disabled={!isAuthenticated || !isIntegrationActive}
          />
        ))}
      </div>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomCreateEventIntegration/index.js